import React, { useState, useEffect } from 'react';
import { SideBarMenu } from '../../molecules';
import { useLocation } from "react-router-dom";
import { useUnreadChatsCount } from '../../../hooks';


const SideBar = () => {
  let location = useLocation();
  const { unreadCount } = useUnreadChatsCount();
  const [links, setLinks] = useState([
    {
      to: '/home',
      image: '/img/homeicon.svg',
      active: location.pathname.split('/')[1] != 'chat'
    },
    {
      to: '/chat',
      image: '/img/chat.svg',
      active: location.pathname.split('/')[1] == 'chat',
      badge: 0
    }
  ]);

  useEffect(() => {
    setLinks(prevLinks => prevLinks.map((link) => {
      if (link.to === '/chat') {
        return ({ ...link, badge: unreadCount });
      }
      return link;
    }));
  }, [unreadCount]);


  return (
    <div className="dashboard-sidebar">
      <SideBarMenu links={links} />
    </div>
  );
}

export { SideBar };
